// This intentionally uses a classic script so raw file:// pages can play media too.
// Keep native video controls while limiting automatic playback to visible demos.
document.addEventListener('DOMContentLoaded', ()=>{
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const darkMode = window.matchMedia('(prefers-color-scheme: dark)');
    const print = window.matchMedia('print');
    const containers = document.querySelectorAll('.theme-video, video[data-viewport-playback]');
    const inViewport = new Set();
    const videosIn = (container)=>container instanceof HTMLVideoElement ? [
            container
        ] : Array.from(container.querySelectorAll('video'));
    const updatePlayback = (container)=>{
        videosIn(container).forEach((video)=>{
            const style = getComputedStyle(video);
            const visible = inViewport.has(container) && !document.hidden && !print.matches && style.display !== 'none' && style.visibility !== 'hidden';
            if (!visible) video.pause();
            else if (!reducedMotion.matches && video.paused) // If autoplay is blocked, the native Play button still works.
            video.play().catch(()=>{});
        });
    };
    const updateAll = ()=>containers.forEach(updatePlayback);
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) inViewport.add(entry.target);
            else inViewport.delete(entry.target);
            updatePlayback(entry.target);
        });
    }, {
        threshold: 0.5
    });
    containers.forEach((container)=>{
        videosIn(container).forEach((video)=>{
            video.autoplay = false;
        });
        observer.observe(container);
    });
    darkMode.addEventListener('change', updateAll);
    print.addEventListener('change', updateAll);
    document.addEventListener('visibilitychange', updateAll);
    reducedMotion.addEventListener('change', ()=>{
        if (reducedMotion.matches) containers.forEach((container)=>{
            videosIn(container).forEach((video)=>video.pause());
        });
        updateAll();
    });
});

//# sourceMappingURL=frontend.99611aec.js.map
